import React from "react";
import "./index.scss";
import TreeView from "devextreme-react/tree-view";
import { IMdaeTreeView } from "./index";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";
import { useDispatch } from "react-redux";
const MdaeTreeView: React.FC<IMdaeTreeView> = (props) => {
  const dispatch = useDispatch();
  return (
    <div className={"sys-mdae-radio-group-container"}>
      <TreeView
        {...props}
        onInitialized={(e) => {
          if (typeof props.onInitialized === "function") props.onInitialized(e);
          configureMdaeWidgetOptionUpdaters(
            props.mdaeDataUpdaterConfig,
            DX_WIDGET_NAMES.DX_TREEE_VIEW,
            e.component,
            dispatch
          );
        }}
      ></TreeView>
    </div>
  );
};
export default MdaeTreeView;
